<div class="container p-0" *ngIf="showDefaultPageBanner">
  <lib-banner [banner]="banner"></lib-banner>
</div>
<div class="container banner-wrapper" *ngIf="!showDefaultPageBanner && !isPastMember">
  <div class="row g-0">
    <div class="d-flex flex-column flex-sm-row">
      <div class="banner-container" [ngStyle]="{ backgroundImage: 'url(' + bannerImage + ')' }">
        <div class="tracker-container d-flex">
          <div class="tracker-data">
            <div class="tracker-progress">
              <h5 class="tracker-title">{{ rebateSummary?.companyName }}</h5>
              <div class="progress-container d-flex align-items-end text-center justify-content-center">
                <div class="progress-arc-baseline"></div>
                <div class="progress-arc" [ngStyle]="{ '--progress': getProgressFillEnd() }"></div>
                <div
                  class="progress-arc-current"
                  [ngStyle]="{ '--start-point': getProgressStartPoint(), '--progress': progressStartPoint }"
                ></div>
                <label [class]="'segment-label-zero'" [id]="'segment-label-zero'">0</label>
                <span class="band-marker"></span>
                <ng-container *ngFor="let targetOption of salesTargetOptions; let i = index">
                  <label
                    [class]="
                      'segment-label-' +
                      targetOption.band.toLowerCase() +
                      '-' +
                      numberOfBands +
                      ' d-flex flex-column generic-class'
                    "
                    [id]="'segment-label-' + i"
                    >{{ 'Band Label' | translate : { band: targetOption.band }
                    }}<span>{{ targetOption.currency.symbol }}{{ targetOption.salesTarget | number }}</span></label
                  >

                  <span
                    [class]="'band-marker band-marker-' + targetOption.band.toLowerCase()"
                    [ngStyle]="{ rotate: calculatedAngle * (i + 1) + 'deg' }"
                  ></span>
                </ng-container>
                <div class="progress-label d-flex flex-column align-items-center">
                  <h4 class="progress-label-title w-75">{{ 'Total Revenue Achieved' | translate }}</h4>
                  <label class="progress-value">
                    <span *ngIf="!rebateSummary">--</span>
                    {{ rebateSummary?.targetCurrencySymbol }}{{ rebateSummary?.qtrRevLocalCurrency | number }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="points-container d-flex flex-column align-items-start justify-content-end">
            <h5 class="qtr-label">{{ getQuarterLabel() }}</h5>
            <h4 class="points-label">{{ 'Total Rebate Achieved' | translate }}</h4>
            <label class="points-value">
              <span *ngIf="!rebateSummary">--</span>
              {{ rebateSummary?.targetCurrencySymbol }}{{ rebateSummary?.rebateDueLocalCurrency | number }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="container banner-wrapper past-members-banner"
  *ngIf="!showDefaultPageBanner && isPastMember"
  [ngStyle]="{ backgroundImage: 'url(' + bannerImagePastMembers + ')' }"
></div>
